import { render, staticRenderFns } from "./MetaWorkingHours.vue?vue&type=template&id=167ded19&"
import script from "./MetaWorkingHours.vue?vue&type=script&lang=js&"
export * from "./MetaWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports